var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Convert AnswersMap to LocalAnswerValues for question enrichment.
 */
var toLocalAnswerValues = function (answersMap) {
    return Object.entries(answersMap).reduce(function (result, _a) {
        var _b;
        var qId = _a[0], answers = _a[1];
        return (__assign(__assign({}, result), (_b = {}, _b[qId] = answers.reduce(function (map, a) {
            var _a;
            return a.id ? __assign(__assign({}, map), (_a = {}, _a[a.id] = a.user_answer_value || '', _a)) : map;
        }, {}), _b)));
    }, {});
};
/**
 * Enrich survey questions with locally collected answer_value so that
 * RadioGroup/Checkboxes/SelectField can detect selections and
 * conditional (blocked_by_default) fields can appear.
 */
export var enrichQuestionsWithLocalAnswers = function (questions, answersMap) {
    if (!questions.length || !Object.keys(answersMap).length) {
        return questions;
    }
    var localValues = toLocalAnswerValues(answersMap);
    return questions.map(function (question) {
        var _a, _b;
        var questionAnswers = localValues[question.id];
        if (!questionAnswers)
            return question;
        return __assign(__assign({}, question), { answers: __assign(__assign({}, question.answers), { nodes: ((_b = (_a = question.answers) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.map(function (answer) {
                    var _a, _b;
                    return (__assign(__assign({}, answer), { answer_value: (_b = (_a = questionAnswers[answer.id]) !== null && _a !== void 0 ? _a : answer.answer_value) !== null && _b !== void 0 ? _b : null }));
                })) || [] }) });
    });
};
/**
 * Build survey_answers_attributes payload from the answers map,
 * suitable for CreateTicketAttributesInput.
 */
export var buildSurveyAnswersPayload = function (answersMap) {
    return Object.entries(answersMap)
        .filter(function (_a) {
        var ans = _a[1];
        return ans.length > 0;
    })
        .map(function (_a) {
        var questionId = _a[0], ans = _a[1];
        return ({
            question_id: questionId,
            answers: ans.map(function (a) { return (__assign({ id: a.id, user_answer_value: a.user_answer_value }, (a.kind && { kind: a.kind }))); })
        });
    });
};
